import { Routes } from '@angular/router';
import { AdminComponent } from './private/admin/admin.component';
import { CiudadanosComponent } from './private/admin/pages/directorio/ciudadanos/ciudadanos.component';
import { DirectorioComponent } from './private/admin/pages/directorio/directorio.component';
import { ReservasComponent } from './private/admin/pages/reservas/reservas.component';
import { CalendarComponent } from './private/admin/pages/calendar/calendar.component';
import { AuthenticationComponent } from './public/authentication/authentication.component';
import { CajeroComponent } from './private/cajero/cajero.component';
import { ReservasCajeroComponent } from './private/cajero/pages/reservas-cajero/reservas-cajero.component';
import { TarifarioComponent } from './private/admin/pages/tarifario/tarifario.component';
import { AdminGuard } from './core/guards/adminauth/adminauth.guard';
import { CajeroGuard } from './core/guards/cajeroauth/cajeroauth.guard';

export const routes: Routes = [
  {
    path: 'login',
    component: AuthenticationComponent,
  },
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: 'admin',
    component: AdminComponent,
   canActivate: [AdminGuard],
    children: [
      { path: '', redirectTo: 'calendar', pathMatch: 'full' },
      { path: 'ciudadanos', component: CiudadanosComponent },
      { path: 'directorio', component: DirectorioComponent },
      { path: 'reservas', component: ReservasComponent },
      { path: 'calendar', component: CalendarComponent },
      { path: 'tarifario', component: TarifarioComponent }
    ],
  },
  {
    path: 'cajero',
    component: CajeroComponent,
    canActivate: [CajeroGuard],
    children: [
      {path: '', redirectTo: 'reservas-cajero', pathMatch: 'full'},
      { path: 'reservas-cajero', component: ReservasCajeroComponent }
    ]
  }
];
